module.exports = __webpack_public_path__ + "img/Dantam Fashion 09.1524519e.jpg";